(function (Drupal, once) {
  'use strict';

  var scrollToAccordionItem = function (element) {
    var offset = 110;
    var top = element.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
      top: top,
      behavior: 'smooth'
    });
  };

  Drupal.behaviors.faqHashOpen = {
    attach: function (context) {
      once('faq-hash-open-init', 'body', context).forEach(function () {
        var hasAutoOpened = false;
        var hashChangeHandler = null;

        var openFromHash = function () {
          if (hasAutoOpened) {
            return;
          }

          var hash = window.location.hash;

          if (!hash || hash.indexOf('#qa-') !== 0) {
            return;
          }

          var target = document.querySelector(hash);
          if (!target || !target.classList.contains('accordion-collapse')) {
            return;
          }

          var trigger = document.querySelector('[data-bs-target="' + hash + '"]');

          if (window.bootstrap && window.bootstrap.Collapse) {
            if (target.classList.contains('show')) {
              scrollToAccordionItem(target);
              hasAutoOpened = true;
              if (hashChangeHandler) {
                window.removeEventListener('hashchange', hashChangeHandler);
              }
              return;
            }

            target.addEventListener('shown.bs.collapse', function () {
              scrollToAccordionItem(target);
              hasAutoOpened = true;
              if (hashChangeHandler) {
                window.removeEventListener('hashchange', hashChangeHandler);
              }
            }, { once: true });

            var collapse = window.bootstrap.Collapse.getOrCreateInstance(target, {
              toggle: false
            });
            collapse.show();
          }
          else {
            target.classList.add('show');
            if (trigger) {
              trigger.classList.remove('collapsed');
              trigger.setAttribute('aria-expanded', 'true');
            }

            scrollToAccordionItem(target);
            hasAutoOpened = true;
            if (hashChangeHandler) {
              window.removeEventListener('hashchange', hashChangeHandler);
            }
          }
        };

        hashChangeHandler = function () {
          openFromHash();
        };

        openFromHash();
        if (!hasAutoOpened) {
          window.addEventListener('hashchange', hashChangeHandler, { passive: true });
        }
      });
    }
  };
})(Drupal, once);
